import {
    Component,
    OnInit,
    EventEmitter,
    Input,
    Output,
    forwardRef,
    ElementRef,
    ViewChild,
    HostListener,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ISelectOption } from '../../../interfaces/select.interfaces';

@Component({
    selector: 'app-select',
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => SelectComponent),
        },
    ],
    standalone: false
})
export class SelectComponent implements OnInit, ControlValueAccessor {
    @Input() public options: ISelectOption[] = [];
    @Input() public value?: ISelectOption;
    @Input() public placeholder = 'Выберите из списка...';
    @Input() public label?: string;
    @Input() public required = false;
    @Input() public theme: 'primary' | 'flat' = 'primary';

    @Output() public onSelectionChange = new EventEmitter<ISelectOption>();
    public onChange = (value: any) => {};

    @ViewChild('select')
    public selectComponentRef!: ElementRef;

    public selectedOptionText!: string;

    public constructor() {}

    public isDropdownOpen: boolean = false;

    public toggleDropdown() {
        this.isDropdownOpen = !this.isDropdownOpen;
    }

    public registerOnChange(fn: any): void {
        this.onChange = fn;
    }
    public registerOnTouched(fn: any): void {}
    public setDisabledState?(isDisabled: boolean): void {}
    public writeValue(obj: any): void {}

    public ngOnInit() {
        // console.log(this.value);
        this.selectedOptionText =
            this.value && this.value.selected
                ? (this.value?.text as string)
                : this.placeholder;
    }

    public selectOption(opt: ISelectOption) {
        this.onSelectionChangeHandler(opt);
        this.isDropdownOpen = false;
    }

    public onSelectionChangeHandler(opt: ISelectOption) {
        this.selectedOptionText = opt.text as string;
        this.value = opt;
        this.onChange(opt);
        this.onSelectionChange.emit(opt);
    }

    @HostListener('document:click', ['$event'])
    public onDocumentClick(event: MouseEvent) {
        const clickedElement = event.target as HTMLElement;
        if (!clickedElement.closest('.select')) {
            this.isDropdownOpen = false;
        }
    }
}
